import React from 'react'
import PropTypes from 'prop-types'

import ProbateCalculator from 'views/probate/components/Calculator'

const WIDGET_COMPONENTS = {
  probateCalculator: ProbateCalculator,
}

const Widget = ({ type }) => {
  const Component = WIDGET_COMPONENTS[type]

  if (!Component) {
    console.warn(`No widget with type ${type}} exists`)
    return null
  }

  return <Component />
}

Widget.propTypes = {
  type: PropTypes.string.isRequired,
}

export default Widget
